import { useState } from 'react'
import { Container, Row, Col } from 'reactstrap'

export default function HelpSection() {
    const [openItem, setOpenItem] = useState<number | null>(null)

    const faqs = [
        {
            id: 1,
            question: 'Preciso pagar para criar minha conta?',
            answer: 'Não. O Clube do Tennis é uma plataforma gratuita com o objetivo de conectar a maior quantidade possível de tenistas.',
        },
        {
            id: 2,
            question: 'Como descubro qual é o meu nível?',
            answer: 'Na etapa final de criação de conta, o Clube do Tennis te mostrará os 7 níveis disponíveis com a explicação de cada um, para que você avalie qual se encaixa melhor no seu momento de jogo.',
        },
        {
            id: 3,
            question: 'Posso cancelar um desafio agendado?',
            answer: 'Sim. Sabemos que imprevistos acontecem, mas é importante avisar o outro jogador com a maior antecedência possível, respeitando o senso de comunidade e ajuda mútua.',
        },
        {
            id: 4,
            question: 'O Clube do Tennis faz locação de quadra?',
            answer: 'Não. Os tenistas que forem participar do Desafio devem entrar em acordo para seleção do local do Desafio e fazer a locação da quadra, caso necessário.',
        },
        {
            id: 5,
            question: 'Como faço para buscar desafios?',
            answer: 'Ao abrir o app, você encontrará jogadores próximos a você, sendo que é possível desafiá-los para partidas ranqueadas ou treinos, dependendo da compatibilidade de nível. Também na aba Jogar, você poderá informar sua disponibilidade e ver a disponibilidade de outros jogadores próximos para jogarem juntos.',
        },
        {
            id: 6,
            question: 'O que mais posso fazer no Clube do Tennis?',
            answer: 'O Clube do Tennis é o local onde a comunidade de tenistas se encontra. Você pode conhecer novos jogadores ou registrar as partidas que você já joga com seus amigos. Também pode ver professores cadastrados próximo a você, participar do Ranking aberto do Clube do Tennis e batalhar para cumprir certos objetivos e ganhar Conquistas.',
        },
    ]

    const toggleItem = (id: number) => {
        setOpenItem(openItem === id ? null : id)
    }

    return (
        <div className="faq-section">
            <div className="faq-section-line" />
            <Container>
                <Row className="align-items-start">
                    <Col lg="6" className="faq-title-col">
                        <div className="faq-title-wrapper">
                            <div className="faq-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" stroke="#D76A13" strokeWidth="2" />
                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="#D76A13" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 17h.01" stroke="#D76A13" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2 className="faq-title">
                                Dúvidas frequentes
                                <br />
                                sobre o Clube do Tennis
                            </h2>
                        </div>
                    </Col>
                    <Col lg="6" className="faq-questions-col">
                        <div className="faq-questions">
                            {faqs.map((faq) => (
                                <div key={faq.id} className="faq-item">
                                    <div
                                        className="faq-question-item"
                                        onClick={() => toggleItem(faq.id)}
                                    >
                                        <span className="faq-question-text">{faq.question}</span>
                                        <svg
                                            className={`faq-arrow ${openItem === faq.id ? 'open' : ''}`}
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M9 18L15 12L9 6" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    {openItem === faq.id && (
                                        <div className="faq-answer">
                                            <p>{faq.answer}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
